import request from 'utils/request'
import { MCAXS100SendHistoryCommentRequest } from 'types/MCAXS100/MCAXS100SendHistoryCommentRequest'

export const commentHistoryApi = (action: MCAXS100SendHistoryCommentRequest) =>
  request({
    url: "/MCAXS100/init",
    method: 'post',
    data: action
  })